import React from "react";
import { apply } from "@credit-key/creditkey-js/lib";
import Cookie from "js-cookie";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import Environment from "~/common/Environment";
import CreditKeyMessage from "./CreditKeyMessage";
import useIsMounted from "~/common/useIsMounted";

interface Props {
  price: number;
  style?: string;
}
const CreditKeyBanner = ({ price, style = "" }: Props) => {
  const publicKey = Cookie.get("CreditKeyPublicKey");
  const minimumDisplayPriceFromCookie = Cookie.get(
    "CreditKeyPdpMinimumDisplayPrice",
  );

  const mounted = useIsMounted();

  const minimumDisplayPrice = minimumDisplayPriceFromCookie
    ? parseInt(minimumDisplayPriceFromCookie, 10)
    : 0;

  const openApplyModal = () => {
    if (publicKey) {
      apply(
        publicKey,
        "modal",
        Environment.primary === "prod" ? "production" : "staging",
      );
    }
  };

  if (price < minimumDisplayPrice || !mounted) {
    return null;
  }

  return (
    <div className={style}>
      {price <= 2400 ? (
        <CreditKeyMessage
          message="4 interest-free payments of"
          payments={formatAsCurrency.formatIfUndefined(price / 4)}
          perMonth=""
          openApplyModal={openApplyModal}
        />
      ) : (
        <CreditKeyMessage
          message="or payments as low as"
          payments={formatAsCurrency.formatIfUndefined(
            (price * 0.0174 * 11 + price) / 12,
          )}
          perMonth="/month"
          openApplyModal={openApplyModal}
        />
      )}
    </div>
  );
};

export default CreditKeyBanner;
